var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C6 2.44772 6.44772 2 7 2H21C21.5523 2 22 2.44772 22 3V17C22 17.5523 21.5523 18 21 18H17V21C17 21.5523 16.5523 22 16 22H3C2.44772 22 2 21.5523 2 21V8C2 7.44772 2.44772 7 3 7H6V3ZM4 9V20H15V9H4ZM17 16V8C17 7.44772 16.5523 7 16 7H8V4H20V16H17Z",
    fill: "#C7CDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fff0e0ef2bc6ab05ae9130a0507715a4.svg";
export { ForwardRef as ReactComponent };